export default (theme) => ({
    root: {
        zIndex: 9999,
        maxWidth: 400,
        outline: 'none',
    },
    content: {
        ...theme.typography.defaultText,
        padding: 16,
        color: theme.colors.textLight.primary,
        lineHeight: 1.4285714,
        textDecoration: 'none',
        backgroundColor: theme.colors.primary.white,
        boxShadow: theme.effects.boxShadow,
        borderRadius: 8,
        wordBreak: 'break-word',
    },
    trigger: {
        display: 'flex',
        alignItems: 'center',
    },
});
